export default interface FeatureFlags {
    sendEmail?: boolean;
    sendEnrollmentExpirationReminders?: boolean;
    sendEventReminders?: boolean;
    generateCertificateFileUponEnrollmentCompletion?: boolean;
    allowProductUnpublish?: boolean;
    allowCourseUnpublish?: boolean;
    showLinkFreeTrialBanner?: boolean;
    showAenProviderFee?: boolean;
    useNetsuiteIdForUserLookup?: boolean;
}

export const DEFAULT_FEATURE_FLAGS: Required<FeatureFlags> = {
    sendEmail: false,
    sendEnrollmentExpirationReminders: false,
    sendEventReminders: false,
    generateCertificateFileUponEnrollmentCompletion: false,
    allowProductUnpublish: false,
    allowCourseUnpublish: false,
    showLinkFreeTrialBanner: false,
    showAenProviderFee: false,
    useNetsuiteIdForUserLookup: false,
};
